import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { addToIdentityPoolOnServerUser } from '~src/authentication/components/identityPools/actions/AddToIdentityPoolAction';
import { removeFromIdentityPoolOnServerUser } from '~src/authentication/components/identityPools/actions/RemoveFromIdentityPoolAction';
import { reloadSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { forcePasswordUpdateOnServerUsers } from '../../authentication/actions/ForcePasswordUpdateAction';
import { resetLoginRateLimitingOnServerUsers } from '../../authentication/actions/ResetLoginRateLimitingAction';
import { ServerUserAddToIdentityPool, ServerUserDelete, ServerUserEditSiteMembership, ServerUserForcePasswordUpdate,
ServerUserRemoveFromIdentityPool, ServerUserResetLoginRateLimiting
} from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { EditSiteMembershipAction } from '../services/EditSiteMembershipAction';
import { RemoveUsersAction } from '../services/RemoveUsersAction';
import { ServerUserMenuAction } from '../users/actions/ServerUserMenuActions';
import { IServerUserInfo } from '../users/models/IServerUserInfo';

export function deleteUsers(users: IServerUserInfo[]) {
  return RemoveUsersAction.showDeleteUsersFromServerDialog(Set.fromIdItemArray(users));
}

export function* handleDeleteUsers(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(deleteUsers, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    // This is to prevent error notifcation from showing up when the dialog is dismissed
    // To be fixed after TFSID 1121927
    return;
  }
}

export function editSiteMembership(users: IServerUserInfo[]) {
  return EditSiteMembershipAction.showEditSiteMembershipDialog(Set.fromIdItemArray(users));
}

export function* handleEditSiteMembership(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(editSiteMembership, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function forcePasswordUpdate(users: IServerUserInfo[]) {
  return forcePasswordUpdateOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleForcePasswordUpdate(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(forcePasswordUpdate, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function resetLoginRateLimiting(users: IServerUserInfo[]) {
  return resetLoginRateLimitingOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleResetLoginRateLimiting(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(resetLoginRateLimiting, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function addToIdentityPool(users: IServerUserInfo[]) {
  return addToIdentityPoolOnServerUser(users[0]);
}

export function* handleAddToIdentityPool(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(addToIdentityPool, action.items);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  } finally {
    /* When a new identity needs to be created as part of the add user to pool action, somehow we get a cancel error
       even though identity creation and add to pool are all successful.
       Reload the subspace anyway to update user's pool info.
    */
    yield call(reloadSpace);
  }
}

export function removeFromIdentityPool(users: IServerUserInfo[]) {
  return removeFromIdentityPoolOnServerUser(users[0]);
}

export function* handleRemoveFromIdentityPool(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(removeFromIdentityPool, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootServerUserMenuActionSaga(): SagaIterator {
  yield takeEvery(ServerUserEditSiteMembership, handleEditSiteMembership);
  yield takeEvery(ServerUserDelete, handleDeleteUsers);
  yield takeEvery(ServerUserForcePasswordUpdate, handleForcePasswordUpdate);
  yield takeEvery(ServerUserResetLoginRateLimiting, handleResetLoginRateLimiting);
  yield takeEvery(ServerUserAddToIdentityPool, handleAddToIdentityPool);
  yield takeEvery(ServerUserRemoveFromIdentityPool, handleRemoveFromIdentityPool);
}
